import types, { ActionCreators } from './types';

const earningMechanismComponentERR: ActionCreators['EarningMechanismComponentERR'] = (
  errorMessages,
  error,
) => ({
  type: types.EARNING_MECHANISM_COMPONENT_ERR,
  errorMessages,
  error,
});

const earningMechanismComponentOK: ActionCreators['EarningMechanismComponentOK'] = (id) => ({
  type: types.EARNING_MECHANISM_COMPONENT_OK,
  id,
});

const requestEarningMechanism: ActionCreators['RequestEarningMechanism'] = (id) => ({
  type: types.REQUEST_EARNING_MECHANISM,
  id,
});

const requestEarningMechanismERR: ActionCreators['RequestEarningMechanismERR'] = (
  errorMessages,
  error,
) => ({
  type: types.REQUEST_EARNING_MECHANISM_ERR,
  errorMessages,
  error,
});

const requestEarningMechanismOK: ActionCreators['RequestEarningMechanismOK'] = (
  selectedAwardConfiguration,
  selectedEMConfiguration,
) => ({
  type: types.REQUEST_EARNING_MECHANISM_OK,
  selectedAwardConfiguration,
  selectedEMConfiguration,
});

const requestEarningMechanismsOK: ActionCreators['RequestEarningMechanismsOK'] = () => ({
  type: types.REQUEST_EARNING_MECHANISMS_OK,
});

const resetInitialEarningMechanismState: ActionCreators['ResetInitialEarninMechanismState'] = (
  earningMechanisms,
) => ({
  type: types.RESET_INITIAL_EARNING_MECHANISM_STATE,
  earningMechanisms,
});

const actions = {
  earningMechanismComponentERR,
  earningMechanismComponentOK,
  requestEarningMechanism,
  requestEarningMechanismERR,
  requestEarningMechanismOK,
  requestEarningMechanismsOK,
  resetInitialEarningMechanismState,
};
export default actions;
